import React from "react";
import { useHistory } from "react-router-dom";

function Board({ dictionary, lingualText, data = [], title }) {
  const history = useHistory();
  
  return (
    <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 height-100">
      <div className="row">
        <div className="col-xl-12 col-md-12">
          <div className="card overflow-hidden">
            <div className="card-header bg-primary text-white">
              {" "}
              {dictionary && dictionary[lingualText] !== undefined
                ? dictionary[lingualText]
                : title}
            </div>
            <div className="row card-dashboard-center">
              <div className="col-xl-12 col-md-12">
                <div className="card-body pb-0 pt-4">
                  <div className={`row w-100 card-dashboard-center`}>
                    {data?.map((type, index) => {
                      return (
                        <div
                          className={`col-xl-2 col-lg-3 col-md-4 col-sm-4 col-xs-6`}
                          key={type.id + index}
                        >
                          <div
                            onClick={() => history.push(`${type.to}`)}
                            className={`card pointer shadow }`}
                          >
                            <div className="card-body text-center">
                              {/*<i className={`${type.icon} text-primary fa-2x`}/>*/}
                              {type.iconSvg}
                              <h6 className="mt-2 fs-12 mb-2">
                                {dictionary &&
                                dictionary[type.lingualText] !== undefined
                                  ? dictionary[type.lingualText]
                                  : type.text}
                              </h6>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Board;
